<template>
	<div>
		<!-- pager -->
		<div class="order-tabs">
			<template v-for="tab in tabs">
				<button :class="['btn', (tab === curTab ? 'btn-primary' : '')]"
						@click="selectTab(tab)">
					{{tab}}
				</button>
			</template>
		</div>

		<!-- content -->
		<div class="main-tab-content" v-show="curTab === 'Opened'">
			<table class="table table-bordered tabled-hover table-stripped">
				<tr>
					<th>Contract</th>
					<th>Side</th>
					<th>Volume</th>
					<th>Enter</th>
					<th>SL</th>
					<th>TP</th>
					<th>Profit</th>
				</tr>
				<tr v-for="(order, index) in openOrders" :key="index">
					<td>{{order.contract}}</td>
					<td>{{order.volume}}</td>
					<td>{{order.side > 0 ? 'BUY' : 'SELL'}}</td>
					<td>{{order.enter}}</td>
					<td>{{order.sl > 0 ? order.sl + '' : ''}}</td>
					<td>{{order.tp > 0 ? order.tp + '' : ''}}</td>
					<td :class="order.profit > 0 ? 'cell-profit' : 'cell-loss'">{{order.profit}}</td>
				</tr>
			</table>
		</div>
		<div class="main-tab-content" v-show="curTab === 'Closed'">
			<table class="table table-bordered tabled-hover table-stripped">
				<tr>
					<th>Contract</th>
					<th>Side</th>
					<th>Volume</th>
					<th>Enter</th>
					<th>Exit</th>
					<th>SL</th>
					<th>TP</th>
					<th>Profit</th>
				</tr>
				<tr v-for="(order, index) in openOrders" :key="index">
					<td>{{order.contract}}</td>
					<td>{{order.volume}}</td>
					<td>{{order.side > 0 ? 'BUY' : 'SELL'}}</td>
					<td>{{order.enter}}</td>
					<td>{{order.exit}}</td>
					<td>{{order.sl > 0 ? order.sl + '' : ''}}</td>
					<td>{{order.tp > 0 ? order.tp + '' : ''}}</td>
					<td :class="order.profit > 0 ? 'cell-profit' : 'cell-loss'">{{order.profit}}</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['portfolio'],
		data() {
			return {
				curTab: 'Opened',
				tabs: ['Opened', 'Closed'],
				openOrders: [],
				closedOrders: []
			};
		},
		computed: {
			portfolioSetUp() {
				return (typeof this.portfolio.id !== 'undefined');
			}
		},
		methods: {
			selectTab(tab) {
				if (tab !== this.curTab)
					this.curTab = tab;
			},
			makeFakeOrders(count) {
				let tickers = [{ name: 'EURUSD', price: 1.2340, prec: 4 }, { name: 'GBPUSD', price: 1.6340, prec: 4 },
							   { name: 'EURCAD', price: 1.0400, prec: 4 }, { name: 'USDJPY', price: 101.20, prec: 2 }, 
							   { name: 'XAGUSD', price: 45.400, prec: 3 }];
				let orders = [];
				for (let i = 0; i < count; i++) {
					let ticker = tickers[Math.floor(Math.random() * tickers.length)];
					let enter = ticker.price * (1 + (Math.random() - 0.5) / 25);
					let exit = enter * (1 + (Math.random() - 0.5) / 45);
					let volume = Math.floor(Math.random() * 20) * 10000;
					let side = Math.random() < 0.5 ? 1 : -1;
					let profit = (side * volume * (exit - enter)).toFixed(2);
					let sl = Math.random() < 0.63 ? 0 : (enter * (1 - side * (Math.random()) / 45));
					let tp = Math.random() < 0.73 ? 0 : (enter * (1 + side * (Math.random()) / 45));

					orders.push({
						contract: ticker.name,
						volume: volume,
						side: side,
						enter: enter.toFixed(ticker.prec),
						exit: exit.toFixed(ticker.prec),
						profit: profit,
						sl: sl.toFixed(ticker.prec),
						tp: tp.toFixed(ticker.prec)
					});
				}
				return orders;
			}
		},
		beforeMount() {
			let openOrders = this.makeFakeOrders(Math.floor(Math.random() * 20 + 2));
			let closedOrders = this.makeFakeOrders(Math.floor(Math.random() * 180 + 2));
			this.$set(this, 'openOrders', openOrders);
			this.$set(this, 'closedOrders', closedOrders);
		}
	};
</script>

<style scoped>
	div.order-tabs {
		display: inline-block;
	}
	.order-tabs button {
		margin: 2px 5px 2px 5px;
	}
	.main-tab-content {
		margin-top: 8px;
		text-align: left;
	}
	.cell-profit {
		color: #308030;
	}
	.cell-loss {
		color: #803030;
	}
</style>